export const TITLE = 'Inventory Status';
export const EXPAND = 'Expand';
export const INVENTORY_UPDATE = 'Inventory Update';
export const CATEGORY = 'Category';
export const SKU_UPDATE = 'SKU Update';
export const STATUS = 'Status';
const SKELETON_COUNT = 4;
export const SKELETON_ARR = Array.from(Array(SKELETON_COUNT));
